import React from 'react';

export const FlippingCardPlusIcon = ({ color = '#FFF', className = '' }) => (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M25.0352 0.882935C11.2282 0.882935 0.0351562 12.0754 0.0351562 25.8829C0.0351562 39.6904 11.2282 50.8829 25.0352 50.8829C38.8422 50.8829 50.0352 39.6904 50.0352 25.8829C50.0352 12.0754 38.8422 0.882935 25.0352 0.882935ZM25.0352 13.3829C26.4159 13.3829 27.5352 14.5029 27.5352 15.8829V23.3829H35.0352C36.4159 23.3829 37.5352 24.5029 37.5352 25.8829C37.5352 27.2629 36.4159 28.3829 35.0352 28.3829H27.5352V35.8829C27.5352 37.2629 26.4159 38.3829 25.0352 38.3829C23.6544 38.3829 22.5352 37.2629 22.5352 35.8829V28.3829H15.0352C13.6544 28.3829 12.5352 27.2629 12.5352 25.8829C12.5352 24.5029 13.6544 23.3829 15.0352 23.3829H22.5352V15.8829C22.5352 14.5029 23.6544 13.3829 25.0352 13.3829Z"
      fill={color}
    />
  </svg>
);

export const FlippingCardCloseIcon = ({ className, onClick }) => (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M25.998 0.882812C12.191 0.882812 0.998047 12.0753 0.998047 25.8828C0.998047 39.6903 12.191 50.8828 25.998 50.8828C39.8055 50.8828 50.998 39.6903 50.998 25.8828C50.998 12.0753 39.8055 0.882812 25.998 0.882812ZM18.498 15.8828C19.1375 15.8828 19.8068 16.0978 20.295 16.5853L25.998 22.2878L31.7005 16.5853C32.1905 16.0978 32.858 15.8828 33.498 15.8828C34.138 15.8828 34.8055 16.0978 35.2955 16.5853C36.2705 17.5628 36.2705 19.2028 35.2955 20.1803L29.593 25.8828L35.2955 31.5853C36.2705 32.5628 36.2705 34.2028 35.2955 35.1803C34.318 36.1553 32.678 36.1553 31.7005 35.1803L25.998 29.4778L20.295 35.1803C19.3188 36.1553 17.6775 36.1553 16.701 35.1803C15.7248 34.2028 15.7248 32.5628 16.701 31.5853L22.403 25.8828L16.701 20.1803C15.7248 19.2028 15.7248 17.5628 16.701 16.5853C17.1895 16.0978 17.8583 15.8828 18.498 15.8828Z"
      fill="url(#paint0_linear_2838_7966)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2838_7966"
        x1="-14.2619"
        y1="65.1683"
        x2="41.4203"
        y2="80.2779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#003DA6" />
        <stop offset="1" stopColor="#2669DC" />
      </linearGradient>
    </defs>
  </svg>
);
